<template>
    <div>
        <WaitingBlock v-if="isLoadingDayTemplates || isLoadingClocks || isLoadingBoxes"></WaitingBlock>
        <DayTemplateStuckedCard v-else-if="(clockList === null || clockList.count === 0) || (boxList === null || boxList.count === 0)"
                     :hasBox="boxList !=null && boxList.count > 0"
                     :hasClock="clockList !=null && clockList.count > 0">
        </DayTemplateStuckedCard>
        <ListEmptyCard v-else-if="(dtList === null || dtList.count === 0)">
        </ListEmptyCard>

        <b-list-group class="list-cards" v-if="(dtList!=null)">
            <!-- v-else -->
            <ItemListCard v-for="dt in dtList.items"
                          :key="dt.uid"
                          :item="dt"
                          @click.native.stop="goToDt(dt)">
                <template slot="Decorator">
                    <ProgressGraph class="decorator" :percentage="dt.statistics.fillPercentage" :colorCode="dt.colorCode"></ProgressGraph>
                </template>
                <template slot="QuickStats">
                    <div class="stat-item">
                        <div>{{dt.statistics.clockCount}}</div>
                            <i class="far fa-clock" v-tooltip="{ data: 'Clock count'}"></i>
                    </div>
                    <div class="stat-item"  >
                        <div>{{dt.statistics.playlistCount}}</div>
                            <i class="fas fa-list-ol" v-tooltip="{ data: 'Playlist count'}"></i>
                    </div>
                    <div class="stat-item">
                        <div>{{dt.statistics.podcastCount}}</div>
                            <i class="far fa-comment" v-tooltip="{ data: 'Podcast count'}"></i>
                    </div>
                    <div class="stat-item">
                        <div>{{minToMoment(dt.statistics.totalDuration).format('HH:mm')}} </div>
                                <i class="far fa-clock" v-tooltip="{ data: 'Total duration', arrowPosition: 'top'}"></i>
                    </div>
                </template>
                <template slot="Menu">
                    <b-dropdown no-caret>
                        <template slot="button-content">
                            <i class='fas fa-ellipsis-v'></i>
                        </template>
                        <b-dropdown-item @click.prevent.stop="startEditDayTemplate(dt.uid)">Settings...</b-dropdown-item>
                        <b-dropdown-item @click.prevent.stop="startDuplicateDayTemplate(dt.uid)">Duplicate</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click.prevent.stop="startDeleteDayTemplate(dt)">Delete</b-dropdown-item>
                    </b-dropdown>
                </template>
            </ItemListCard>
        </b-list-group>
    </div>
</template>

<script>
    import store from '@/store'
    import Portlet from'@/components/common/Portlet.vue'
    import WaitingBlock from'@/components/common/WaitingBlock.vue'
    import ItemListCard from'@/components/common/PlannerItemListCard.vue'
    import ProgressGraph from'@/components/common/Graph.vue'
    import DayTemplateStuckedCard from './DayTemplateStuckedCard.vue'
    import ListEmptyCard from './ListEmptyCard.vue'
    import Tooltip from '@/components/common/Tooltip.vue';
    import { mapState, mapMutations, mapActions } from 'vuex';
    import EventBus from '@/eventbus';

    export default {
        name: 'DayTemplateIndex',
        store,
        components: {
            Portlet, WaitingBlock, DayTemplateStuckedCard, ListEmptyCard, ItemListCard, ProgressGraph, Tooltip
        },

        computed: {
            ...mapState({
                isLoadingDayTemplates: state => state.loadingStates.isLoadingStationDayTemplates,
                isLoadingBoxes: state => state.loadingStates.isLoadingStationBoxes,
                isLoadingClocks: state => state.loadingStates.isLoadingStationClocks,
                dtList: state => state.stationDayTemplates,
                clockList: state => state.stationClocks,
                boxList: state => state.stationBoxes
            })
        },
        data() {
            return {
                viewState: {
                    showDeleteConfirmation: false
                },
                currentClock: null
            }
        },
        mounted() {
            const { stationUid } = this.$route.params;
            this.$store.dispatch('loadStationDayTemplates', stationUid);
        },
        methods: {
            dayTemplateDeleted() {
                this.$store.dispatch('loadStationDayTemplates', this.$store.state.currentStationUid);
            },
            startDeleteDayTemplate(dt) {
                EventBus.$emit("onDayTemplateDelete", dt.uid);
            },
            startDuplicateDayTemplate(uid) {
                EventBus.$emit("onDayTemplateDuplicate", uid);
            },
            startEditDayTemplate(uid) {
                EventBus.$emit("onDayTemplateEdition", uid);
            },
            onClick(clock) {
                this.activateClock(clock);
            },
            goToDt(dt){
                this.$router.push({
                    name:'DayTemplateDetails',
                    params:{
                        dayTemplateUid: dt.uid
                    }
                })
            }
        }
    };

</script>

<style >
    section.page-section, .pad{
        padding: 0 15px 15px;
    }
</style>
